export const contentTypes = [
  "Landscape Logo",
  "Square Logo",
  "TV Display",
  "Certificate",
  "Video Call Background",
  "Poster",
  "FAQ",
  "Multipage FAQ",
  "Manager One-Pager",
  "Horizontal Banner",
  "Guide",
  "Video",
  "Uploaded File",
];
